import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";
import ColorPanel from "./signature-tools/ColorPanel";
import BrushPanel from "./signature-tools/BrushPanel";
import middleware from "../../middleware";

const WeaSignature = Loadable({
  loader: () => import("./SignatureNew"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
WeaSignature.ColorPanel = middleware(ColorPanel, "WeaSignature.ColorPanel");
WeaSignature.BrushPanel = middleware(BrushPanel, "WeaSignature.BrushPanel");
export default WeaSignature;



// WEBPACK FOOTER //
// ./ecology9/wea-signature/index.js